import { createChatBotMessage } from "react-chatbot-kit";
import DogPicture from "./DogPicture";
import MyAvatar from "./MyAvatar";
import BotDashboardResponse from "./Response/BotDashboardResponse";
import BotEventResponse from "./Response/BotEventResponse";
import BotCurrentEventResponse from "./Response/BotCurrentEventResponse";
import BotMembershipResponse from "./Response/BotMembershipResponse";
import BotExplainWithImage from "./Response/BotExplainWithImage";
import BotExplainImageOptionsLayout from "./Response/BotExplainImageOptionsLayout";


const botName = "NMM Bot"


const getGreetingMessage = () => {
  const currentHour = new Date().getHours();
  if (currentHour < 12) {
    return "Good Morning! I'm NMM Bot. How can I help you?";
  } else if (currentHour < 18) {
    return "Good Afternoon! I'm NMM Bot. How can I help you?";
  } else {
    return "Good Evening! I'm NMM Bot. How can I help you?";
  }
};





const getOptionsMessage = () => {
  return createChatBotMessage("Please select an option:", {
    widget: 'smallTalk', 
  });
};

const buttonStyle = {
  padding: '8px 12px',
  borderRadius: '8px',
  border: '1px solid rgba(88,106,217,.2)',
  backgroundColor: '#eef0fb',
  color: '#586AD9',
  fontSize: '13px',
  fontWeight: '600',
  cursor: 'pointer',
  transition: 'all 0.15s',
};

const config = {
    initialMessages: [createChatBotMessage(getGreetingMessage()), getOptionsMessage()],
    botName: botName,
    customStyles: {
        botMessageBox: {
            backgroundColor: '#586AD9'
        },
        chatButton: {
            backgroundColor: '#586AD9'
        },
        userMessageBox: {
            backgroundColor: '#f1f5f9'
        }
    },
    customComponents: {
        header: () => null,
    },
    widgets: [
        {
            widgetName: 'dogPicture',
            widgetFunc: (props) => <DogPicture {...props} />
        },
        
        {
          widgetName: 'dashboardWidget',
          widgetFunc: (props) => <BotDashboardResponse {...props} />
        },
        {
          widgetName: 'eventWidget',
          widgetFunc: (props) => <BotEventResponse {...props} />
        },
        {
          widgetName: 'currentEventsWidget',
          widgetFunc: (props) => <BotCurrentEventResponse {...props} currentOrPast={"current"}/>
        },
        {
          widgetName: 'pastEventsWidget',
          widgetFunc: (props) => <BotCurrentEventResponse {...props} currentOrPast={"past"}/>
        },
        {
          widgetName: 'countdownWidget',
          widgetFunc: (props) => <BotExplainWithImage {...props} imgSrc={`${process.env.PUBLIC_URL}/m_countdown.png`} text={"📅 At the top of the dashboard, you’ll see how many days are left before your membership ends. This helps you stay aware and renew on time."} onBack={props.actionProvider.handleDashboard}/>
        },
        {
          widgetName: 'statisticsWidget',
          widgetFunc: (props) => <BotExplainWithImage {...props} imgSrc={`${process.env.PUBLIC_URL}/m_statistics.png`} text={"📊 Dashboard shows quick statistics like: "} points={[
          "Total Companies → how many companies are in the network",
          "Active Members → number of currently active members",
          "Members in Regions → members grouped by region (e.g., 0 Members in Åland Islands)",
          "Exclusive Membership Plan → your membership type and validity dates"
          ]} onBack={props.actionProvider.handleDashboard}/>
        },
        {
          widgetName: 'newsWidget', 
          widgetFunc: (props) => <BotExplainWithImage {...props} imgSrc={`${process.env.PUBLIC_URL}/m_news.png`} text={"📰 The News Section shows latest updates and announcements. You can click 'View All' to explore more."} onBack={props.actionProvider.handleDashboard}/>
        },
        {
          widgetName: 'recentMemberWidget', 
          widgetFunc: (props) => <BotExplainWithImage {...props} imgSrc={`${process.env.PUBLIC_URL}/m_recent.png`} text={"👥 This shows the latest members who joined the platform. Each card shows their Company Name, Country, and Logo. You can click View All to see the complete list."} onBack={props.actionProvider.handleDashboard}/>
        },
        {
          widgetName: 'membersByCountryWidget', 
          widgetFunc: (props) => <BotExplainWithImage {...props} imgSrc={`${process.env.PUBLIC_URL}/m_members.png`} text={"🌍 The Dashboard also has a world map showing members by country. The color shade indicates how many members are in that country:"} points={["Lighter colors = fewer members", "Darker colors = more members", "Hover over a country to see the exact number of members"]} onBack={props.actionProvider.handleDashboard}/>
        },
        {
          widgetName: 'eventsWidget', 
          widgetFunc: (props) => <BotExplainWithImage {...props} imgSrc={`${process.env.PUBLIC_URL}/m_events.png`} text={"📅 The Events section helps you explore ongoing and past events."} />
        },
        {
          widgetName: 'membershipWidget', 
          widgetFunc: (props) => <BotExplainWithImage {...props} imgSrc={`${process.env.PUBLIC_URL}/m_membership.png`} text={"🎫 The Membership Plan section shows available plans and your current subscription. You can compare features and upgrade if needed."} />
        },
        {
          widgetName: 'viewImpactWidget', 
          widgetFunc: (props) => <BotExplainWithImage {...props} text={"💼 View Impact shows your Business Wallet. This is like a transaction ledger that records your financial interactions."} onBack={props.actionProvider.handleBusinessImpact} />
        },
        {
          widgetName: 'makeTransactionWidget', 
          widgetFunc: (props) => <BotExplainWithImage {...props} imgSrc={`${process.env.PUBLIC_URL}/m_maketrans.png`} text={"💳 Make Transaction allows member-to-member payments or requests."} points={[
            "Click 'Pay' to make a payment.",
            "Click 'Request' to ask another member for payment."
          ]} zonBack={props.actionProvider.handleBusinessImpact} />
        },
        {
          widgetName: 'newFreightReqWidget', 
          widgetFunc: (props) => <BotExplainWithImage {...props} imgSrc={`${process.env.PUBLIC_URL}/m_newreq.png`} text={"📝 New Request lets you create a shipment request. Fill out the form with shipment details to ask for service."} points={[
            "Provide shipment details in the form",
            "Click 'Submit' to send request to members"
          ]} onBack={props.actionProvider.handleFreightRequest} />
        },
        {
          widgetName: 'manageReqWidget', 
          widgetFunc: (props) => <BotExplainWithImage {...props} text={"📂 Manage Requests."} points={[
            "📤 Request Sent → requests you sent to others",
            "📥 Request Received → requests you got from others",
            "✅ Request Accept → requests you agreed to handle"
          ]} onBack={props.actionProvider.handleFreightRequest} />
        },
        {
          widgetName: "myProfileWidget",
          widgetFunc: (props) => (
            <BotExplainWithImage
              {...props}
              text="👤 My Profile shows your company details and timeline. You can edit information and post updates."
              imgSrc={`${process.env.PUBLIC_URL}/m_userprofile.png`}
              imgSrc1={`${process.env.PUBLIC_URL}/m_userprofile1.png`}
              points={[
                "View and edit company details and social links",
                "Change cover photo or profile picture",
                "Post updates (text, photos, videos, music)",
                "Edit or delete past posts"
              ]}
              onBack={props.actionProvider.handleUserProfileMenu}
              actionProvider={props.actionProvider}
            />
          ),
        },

        {
          widgetName: "userListWidget",
          widgetFunc: (props) => (
            <BotExplainWithImage
              {...props}
              text="📋 User List shows all members on the platform."
              imgSrc={`${process.env.PUBLIC_URL}/m_userlist.png`}
              points={[
                "Browse members by company name, email, and contact",
                "See logos for quick identification"
              ]}
              onBack={props.actionProvider.handleUserProfileMenu}
              actionProvider={props.actionProvider}
            />
          ),
        },

        {
          widgetName: "recentMembersWidget",
          widgetFunc: (props) => (
            <BotExplainWithImage
              {...props}
              text="🆕 Recent Members shows a list of the newest members."
              imgSrc={`${process.env.PUBLIC_URL}/m_recentmember.png`}
              points={[
                "View company name, email, contact, and country",
                "Quickly discover new members to connect with"
              ]}
              onBack={props.actionProvider.handleUserProfileMenu}
              actionProvider={props.actionProvider}
            />
          ),
        },
        {
          widgetName: "invoicesWidget",
          widgetFunc: (props) => (
            <BotExplainWithImage
              {...props}
              text="📄 The Invoices section shows a list of your invoices, including their status."
              imgSrc={`${process.env.PUBLIC_URL}/m_invoices.png`}
              imgSrc1={`${process.env.PUBLIC_URL}/m_invoices1.png`}
              points={[
                "Each invoice shows number, type, company, dates, amount, and status (Pending, Paid, Overdue)",
                "Click the eye icon to view details of a specific invoice",
                "If an invoice is Pending or Overdue, you can pay directly from the table"
              ]}
              actionProvider={props.actionProvider}
            />
          ),
        },
        {
          widgetName: "timelineWidget",
          widgetFunc: (props) => (
            <BotExplainWithImage
              {...props}
              text="🕒 The Timeline is your community feed where you can post updates and see activities."
              imgSrc={`${process.env.PUBLIC_URL}/m_timeline.png`}
              points={[
                "Write a new post in the 'What's on your mind?' box",
                "Attach a photo, video, or music to your post",
                "Click Post to share your update",
                "Scroll down to see your past posts",
                "Delete old posts if needed",
                "On the right side, click Read More on Latest News cards to view full articles"
              ]}
              
              actionProvider={props.actionProvider}
            />
          ),
        },
        {
          widgetName: "chatWidget",
          widgetFunc: (props) => (
            <BotExplainWithImage
              {...props}
              text="💬 The Chat section lets you connect and talk with other members in real time."
              imgSrc={`${process.env.PUBLIC_URL}/m_chat.png`}
              points={[
                "Search for people or groups to start a chat",
                "See your list of recent chats on the left",
                "Click a member’s name to open the chat",
                "Type your message in the box and press Enter to send",
                "Check the Notifications tab for new chat alerts"
              ]}
              backAction="handleMainMenu"
              actionProvider={props.actionProvider}
            />
          ),
        },
        {
          widgetName: "helpWidget",
          widgetFunc: (props) => (
            <BotExplainWithImage
              {...props}
              text="❓ The Help section provides guidance and examples for using different parts of the platform."
              imgSrc={`${process.env.PUBLIC_URL}/m_help.png`}
              points={[
                "See short explanations for each feature (Home Page, Events, News, etc.)",
                "View small pictures to understand how each section looks",
                "Use this as a quick reference guide anytime you are unsure"
              ]}
              actionProvider={props.actionProvider}
            />
          ),
        },
        {
          widgetName: 'businessImpactWidget', 
          widgetFunc: (props) => <BotExplainImageOptionsLayout {...props}
          text={"📊 Business Impact helps you track your wallet and make transactions with other members."}
          options={[
            {
              label: "View Impact",
              action: props.actionProvider.handleViewImpact
            },
            {
              label: "Make Transaction",
              action: props.actionProvider.handleMakeTransaction
            }
          ]} />
        },
        {
          widgetName: 'freightRequestWidget', 
          widgetFunc: (props) => <BotExplainImageOptionsLayout {...props}
          text={"🚚 The Freight Request section helps you send, receive, and manage shipment requests with other members."}
          options={[
            {
              label: "New Request",
              action: props.actionProvider.handleNewFreightReq
            },
            {
              label: "Request Sent",
              action: props.actionProvider.handleManageRequest
            },
            {
              label: "Request Received",
              action: props.actionProvider.handleManageRequest
            },
            {
              label: "Request Accept",
              action: props.actionProvider.handleManageRequest
            }
          ]} />
        },
        {
          widgetName: "userProfileMenuWidget",
          widgetFunc: (props) => (
            <BotExplainImageOptionsLayout
              {...props}
              text="👤 The User Profile section lets you manage your profile, view all members, and connect with new members."
              options={[
                { label: "My Profile", action: props.actionProvider.handleMyProfile },
                { label: "User List", action: props.actionProvider.handleUserList },
                { label: "Recent Members", action: props.actionProvider.handleRecentMembersInProfile },
              ]}
              onMainMenu={() => props.actionProvider.handleMainMenu()}
              actionProvider={props.actionProvider}   // 👈 pass this down
            />
          ),
        },
        {
          widgetName: "dashboardMenuWidget",
          widgetFunc: (props) => (
            <BotExplainImageOptionsLayout
              {...props}
              text="📊 The Dashboard gives you a quick overview of your membership, statistics, and network activity."
              imgSrc={`${process.env.PUBLIC_URL}/m_dashboard.png`}
              options={[
                { label: "1. Membership Expiry", action: props.actionProvider.handleExpiryCountdown },
                { label: "2. Statistics Cards", action: props.actionProvider.handleStatistics },
                { label: "3. News Section", action: props.actionProvider.handleNewsInDashboard },
                { label: "4. Recent Members", action: props.actionProvider.handleRecentMembers },
                { label: "5. Members by Country", action: props.actionProvider.handleMembersByCountry },
              ]}
              mainMenuAction="handleMainMenu"
              actionProvider={props.actionProvider}
            />
          ),
        },
        {
          widgetName: "newsWidget1",
          widgetFunc: (props) => (
            <BotExplainWithImage
              {...props}
              text="📰 The News section keeps you updated with industry articles and announcements."
              imgSrc={`${process.env.PUBLIC_URL}/m_news1.png`}
              points={[
                "See a grid of news cards with image, title, and short description",
                "Each card also shows the date of the news",
                "Click on a card to read the full article"
              ]}
              actionProvider={props.actionProvider}
            />
          ),
        },
        {
          widgetName: "smallTalk",
          widgetFunc: (props) => {
            const menuOptions = [
              { label: "Dashboard", action: props.actionProvider.handleDashboard },
              { label: "Events", action: props.actionProvider.handleEvents },
              { label: "News", action: props.actionProvider.handleNews },
              { label: "Membership Details", action: props.actionProvider.handleMembership },
              { label: "Business Impact", action: props.actionProvider.handleBusinessImpact },
              { label: "Freight Request", action: props.actionProvider.handleFreightRequest },
              { label: "User Profile", action: props.actionProvider.handleUserProfileMenu },
              { label: "Invoices", action: props.actionProvider.handleInvoices },
              { label: "Timeline (Community)", action: props.actionProvider.handleTimeline },
              { label: "Chat (Community)", action: props.actionProvider.handleChat },
              { label: "Help (Community)", action: props.actionProvider.handleHelp },
            ];
        
            return (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "10px"
                }}
              >
                {menuOptions.map((option, idx) => (
                  <button
                    key={idx}
                    className="btn btn-sm"
                    onClick={option.action}
                    style={{
                      ...buttonStyle,
                      flex: "1 1 calc(50% - 10px)"  // 2 buttons per row
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#eef0fb") &&
                      (e.currentTarget.style.color = "#3A3DBB")
                    }
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#eef0fb";
                      e.currentTarget.style.color = "#586AD9";
                    }}
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            );
          },
        }
    ]
}


export default config;